import React from 'react';

const Testimonials = ({ type = 'university' }) => {
  const universityTestimonials = [
    {
      name: "Carlos M.",
      role: "Dueño de Agencia",
      image: "https://ui-avatars.com/api/?name=Carlos+M&background=c8784e&color=fff&size=128",
      text: "Gracias a JGM University pasé de 0 a manejar 3 modelos en 2 meses. El acompañamiento 1 a 1 fue clave para escalar rápido.",
      rating: 5,
      result: "3 modelos en 2 meses"
    },
    {
      name: "Ana L.",
      role: "Manager OnlyFans",
      image: "https://ui-avatars.com/api/?name=Ana+L&background=c8784e&color=fff&size=128",
      text: "El módulo de chatting cambió todo. Ahora manejo los mensajes de 5 modelos y genero ingresos consistentes cada mes.",
      rating: 5,
      result: "$8K+ mensuales"
    },
    {
      name: "Roberto S.",
      role: "Estudiante del Curso",
      image: "https://ui-avatars.com/api/?name=Roberto+S&background=c8784e&color=fff&size=128",
      text: "Nunca había trabajado con OnlyFans y ahora tengo mi propia agencia funcionando. Los 10 módulos cubren TODO lo que necesitas.",
      rating: 5,
      result: "Agencia propia en 3 meses"
    }
  ];

  const modelTestimonials = [
    {
      name: "Valentina R.",
      role: "Modelo JGM",
      image: "https://ui-avatars.com/api/?name=Valentina+R&background=c8784e&color=fff&size=128",
      text: "Trabajar con JGM Agency cambió mi vida. El equipo me ayuda con todo: contenido, chatting y marketing. Yo solo me enfoco en crear.",
      rating: 5,
      months: "8 meses con JGM"
    },
    {
      name: "Sofía M.",
      role: "Modelo JGM",
      image: "https://ui-avatars.com/api/?name=Sofia+M&background=c8784e&color=fff&size=128",
      text: "Antes trabajaba sola y ganaba poco. Con JGM multipliqué mis ingresos x5. El soporte es increíble y siempre están ahí.",
      rating: 5,
      months: "1 año con JGM"
    },
    {
      name: "Isabella G.",
      role: "Modelo JGM",
      image: "https://ui-avatars.com/api/?name=Isabella+G&background=c8784e&color=fff&size=128",
      text: "Lo mejor es que puedo enfocarme en mi contenido mientras ellos manejan todo lo demás. Es trabajo en equipo de verdad.",
      rating: 5,
      months: "6 meses con JGM"
    }
  ];

  const testimonials = type === 'university' ? universityTestimonials : modelTestimonials;

  return (
    <section className="py-12 md:py-20 px-4" data-section="testimonials">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-3 md:mb-4">
            {type === 'university' ? 'Lo que dicen nuestros estudiantes' : 'Testimonios de nuestras modelos'}
          </h2>
          <p className="text-sm md:text-base text-gray-400">
            {type === 'university' 
              ? 'Resultados reales de personas que tomaron el curso' 
              : 'Experiencias reales de modelos que trabajan con nosotros'}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-6">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-black/60 backdrop-blur-sm border border-[#c8784e]/30 rounded-xl p-6 hover:border-[#c8784e] hover:bg-black/70 transition-all duration-300 hover:shadow-lg hover:shadow-[#c8784e]/20"
            >
              {/* Rating Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <svg key={i} className="w-5 h-5 text-[#c8784e]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-300 text-sm md:text-base mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>

              {/* Author Info */}
              <div className="flex items-center gap-4 pt-4 border-t border-gray-700/50">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full border-2 border-[#c8784e]"
                />
                <div>
                  <p className="text-white font-semibold text-sm">{testimonial.name}</p>
                  <p className="text-gray-400 text-xs">{testimonial.role}</p>
                  {testimonial.result && (
                    <p className="text-[#c8784e] text-xs font-semibold mt-1">✓ {testimonial.result}</p>
                  )}
                  {testimonial.months && (
                    <p className="text-[#c8784e] text-xs font-semibold mt-1">✓ {testimonial.months}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
